import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Keeps <html lang> and <html dir> in sync with the active i18n language.
 * Arabic renders RTL; everything else renders LTR.
 */
export const useDirection = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = (lng: string) => {
      const isAr = lng.startsWith("ar");
      const html = document.documentElement;
      html.setAttribute("lang", isAr ? "ar" : "en");
      html.setAttribute("dir", isAr ? "rtl" : "ltr");
    };
    apply(i18n.language);
    i18n.on("languageChanged", apply);
    return () => {
      i18n.off("languageChanged", apply);
    };
  }, [i18n]);
};